import React, { useEffect, useState } from "react";
import { apiClient } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Plus, Trash2, AlertTriangle } from "lucide-react";

export default function Inventory() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", quantity: "", unit: "kg", min_threshold: "" });
  const load = () => apiClient().get("/materials").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try {
      await apiClient().post("/materials", { ...form, quantity: Number(form.quantity), min_threshold: Number(form.min_threshold) });
      setForm({ name: "", quantity: "", unit: "kg", min_threshold: "" });
      toast.success("Material added");
      load();
    } catch { toast.error("Failed"); }
  };
  const del = async (id) => { await apiClient().delete(`/materials/${id}`); load(); };

  return (
    <div className="space-y-6 fade-in-up" data-testid="inventory-page">
      <div>
        <h1 className="font-display text-5xl mt-1">Material Inventory</h1>
      </div>

      <form onSubmit={add} className="border border-border bg-card p-5 grid md:grid-cols-5 gap-3" data-testid="material-form">
        <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
          data-testid="material-name" aria-label="Material name" className="border border-border bg-background px-3 py-2 text-sm" />
        <input required type="number" value={form.quantity} onChange={(e) => setForm({ ...form, quantity: e.target.value })}
          data-testid="material-qty" aria-label="Quantity" className="border border-border bg-background px-3 py-2 text-sm" />
        <input required value={form.unit} onChange={(e) => setForm({ ...form, unit: e.target.value })}
          data-testid="material-unit" aria-label="Unit" className="border border-border bg-background px-3 py-2 text-sm" />
        <input type="number" value={form.min_threshold} onChange={(e) => setForm({ ...form, min_threshold: e.target.value })}
          data-testid="material-threshold" aria-label="Minimum threshold" className="border border-border bg-background px-3 py-2 text-sm" />
        <button data-testid="material-add-btn" className="btn-sharp inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-4 py-2">
          <Plus className="h-4 w-4" /> Add
        </button>
      </form>

      <div className="border border-border bg-card">
        <table className="w-full text-sm">
          <thead className="border-b border-border">
            <tr className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
              <th className="text-left px-4 py-3">Item</th>
              <th className="text-left px-4 py-3">Qty</th>
              <th className="text-left px-4 py-3">Threshold</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-right px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={5} className="text-center py-8 text-muted-foreground">No materials yet</td></tr>
            )}
            {items.map((it) => {
              const low = it.quantity <= it.min_threshold;
              return (
                <tr key={it.id} className="border-b border-border" data-testid={`material-row-${it.id}`}>
                  <td className="px-4 py-3">{it.name}</td>
                  <td className="px-4 py-3 mono text-primary">{it.quantity} {it.unit}</td>
                  <td className="px-4 py-3 mono">{it.min_threshold} {it.unit}</td>
                  <td className="px-4 py-3">
                    {low ? (
                      <span className="inline-flex items-center gap-1 text-destructive text-xs mono uppercase tracking-wider"><AlertTriangle className="h-3 w-3" /> Low</span>
                    ) : (
                      <span className="text-xs mono uppercase tracking-wider text-emerald-500">Adequate</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button onClick={() => del(it.id)} data-testid={`material-del-${it.id}`} className="text-muted-foreground hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
